module.exports = __webpack_public_path__ + "static/9-0d312cbda0f2b65aa56565a242187400.jpg";